export default __webpack_public_path__ + "static/media/icon_shop.fc057cf6.svg";